import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const options = ref({});
const series = ref([44, 55, 41, 17, 15]);

return (_ctx: any,_cache: any) => {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_apexchart, {
      width: "380",
      type: "donut",
      options: options.value,
      series: series.value
    }, null, 8, ["options", "series"])
  ]))
}
}

})